<script>
import sl from '@/Prevodi/CamoPlovila-sl.json';
import en from '@/Prevodi/CamoPlovila-en.json';
import it from '@/Prevodi/CamoPlovila-it.json';
import {i18n} from "@/i18n";
import Notification from "@/components/reUse/Notification.vue";
import DropDown from "@/components/reUse/DropDown.vue";
import * as bootstrap from 'bootstrap';

export default {
  name: "CamoPlovila",
  components: {DropDown, Notification},
  data() {
    return {
      prevodi: false,
      letala: [],
      izbranoLetalo: [],
      searchLetala: '',
      searchType: 'registracija',
      modalPrikaz: 'pregled',
      prenos: false,
      posiljanje: false,
      //obvestila
      text: '',
      types: '',
      ShowNoti: false,
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    this.BeriPlovila();
  },
  computed: {
    FilterLetal() {
      if(this.searchLetala !== '') {
        if(this.searchType === 'tip') {
          return this.letala.filter(letalo => letalo.tip.toLowerCase().includes(this.searchLetala.toLowerCase()));
        }else if(this.searchType === 'registracija') {
          return this.letala.filter(letalo => letalo.registracija.toLowerCase().includes(this.searchLetala.toLowerCase()));
        }else if(this.searchType === 'vrsta') {
          return this.letala.filter(letalo => letalo.vrsta_letala.toLowerCase().includes(this.searchLetala.toLowerCase()));
        }else{
          return this.letala.filter(letalo => letalo.klub.toLowerCase().includes(this.searchLetala.toLowerCase()));
        }
      }
      return this.letala;
    }
  },
  methods: {
    BeriPlovila() {
      axios
          .get("./api/sifranti/letala/izpis/")
          .then((response) => {
            this.letala = response.data.letala.filter(letalo => letalo.camo_pregled);
          })
          .catch(function (napaka) {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = 'Napaka pri branju podatkov. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri branju podatkov.';
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    Podrobno(id) {
      this.izbranoLetalo = this.letala.filter(letalo => letalo.id === id);
      const modalElement = this.$refs.modalKarticaLetala;
      if (modalElement) {
        const modal = bootstrap.Modal.getOrCreateInstance(
            modalElement,
            // options
        );
        modal.show();
      }

    },
    PodrobnoOff() {
      const modalElement = this.$refs.modalKarticaLetala;
      if (modalElement) {
        const modal = bootstrap.Modal.getOrCreateInstance(
            modalElement,
            // options
        );
        modal.hide();
      }
      //ponastavitev podatkov
      this.uVlecno = '';
      this.uTip = '';
      this.uKlub = '';
      this.uSt_ur = '';
      this.uSt_letov = 0;
      this.uVrsta_letala = '';
      this.uDatum_nakupa = '';
      this.uDatum_registracije = '';
      this.uOpomba = '';
      this.urejanje = false;
      this.izbranoLetalo = [];
    },
    PrenosPdf() {
      this.prenos = true;
      let podatki =new URLSearchParams;
      podatki.append('podatki_letala', JSON.stringify(this.izbranoLetalo));
      podatki.append('akcija', 'tisk');
      axios.post('./api/camo/letala/pdf/', podatki, {withCredentials: true, responseType: 'blob'}).then((response) => {
        this.prenos = false;
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      }).catch((napaka) => {
        this.prenos = false;
        console.log(napaka);
      });
    },
    SendToMail() {
      this.posiljanje = true;
      let podatki =new URLSearchParams;
      podatki.append('podatki_letala', JSON.stringify(this.izbranoLetalo));
      podatki.append('akcija', 'email');
      axios.post('./api/camo/letala/pdf/', podatki, {withCredentials: true, responseType: 'blob'}).then((response) => {
        const blob = new Blob([response.data], {
          type: 'application/pdf'
        });
        const url = URL.createObjectURL(blob);
        const podatkiMail = new FormData();
        podatkiMail.append('datoteka', blob, this.izbranoLetalo[0].registracija +'.pdf');
        podatkiMail.append('zadeva', 'Izpisek podatkov plovila '+ this.izbranoLetalo[0].registracija);
        axios.post('./api/camo/mail/', podatkiMail, {withCredentials: true}).then((response) => {
          // alert(response.data.sporocilo);
          this.text = (response.data.sporocilo);
          this.types = "Uspešno";
          this.ShowNoti = true;
          this.posiljanje = false;
        }).catch((napaka) => {
          if (napaka.response.status === 401) {
            this.$router.push('/Logout');
          }
          if (napaka.response.data.napaka !== undefined) {
            this.text = 'Napaka pri pošiljanju podatkov. ' + napaka.response.data.napaka;
          } else {
            this.text = 'Napaka pri pošiljanju podatkov.';
          }
          this.types = 'Napaka';
          this.ShowNoti = true;
          this.posiljanje = false;
        });
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
        this.posiljanje = false;
      });
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
  }
}
</script>

<template>
  <div class="pregled-povrsin-container" v-if="prevodi">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-angle-double-left"></i>
            <span> {{ $t('plovila.buttons.nazajGlavni') }} </span>
          </button>
          &nbsp;
          <button class="back-btn" @click="$router.push('/pregledi/Camo')">
            <i class="fas fa-arrow-left"></i>
            <span> {{ $t('plovila.buttons.nazaj') }} </span>
          </button>
        </div>
        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title"> {{ $t('plovila.main.title') }}</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>
      </div>
    </div>
  </div>
  <main class='container p-4'>
    <Transition name="fade">
      <Notification v-if="ShowNoti" :message="this.text" :type="this.types"  @closeNotification="ShowNoti = false" />
    </Transition>
    <br>
    <div class="col-12 sticky bg-wingsi p-4">
      <div class="container">
        <div class="btn-group mb-2" role="group">
          <button
              type="button"
              class="btn"
              :class="searchType === 'registracija' ? 'btn-primary' : 'btn-outline-primary'"
              @click="searchType = 'registracija'"
          >
            Registracija
          </button>

          <button
              type="button"
              class="btn"
              :class="searchType === 'tip' ? 'btn-primary' : 'btn-outline-primary'"
              @click="searchType = 'tip'"
          >
            Tip
          </button>

          <button
              type="button"
              class="btn"
              :class="searchType === 'vrsta' ? 'btn-primary' : 'btn-outline-primary'"
              @click="searchType = 'vrsta'"
          >
            Vrsta
          </button>
        </div>

        <div class="position-relative">
          <input
              class="input border-0 rounded-4 p-2 pe-5 fs-5"
              type="text"
              :placeholder="searchType === 'tip'
          ? 'Išči po tipu'
          : searchType === 'klub'
            ? 'Išči po klubu' :
            searchType === 'registracija' ?
            'Išči po registraciji'
            : 'Išči po vrsti plovila'"
              v-model="searchLetala"
          />

          <i class="fas fa-search iskalnik"></i>
        </div>

      </div>
    </div>

    <div class="pregled-povrsin-container">
      <div class='section-content'>
        <!-- desktop -->
        <div class="desktop-grid">
          <div class="grid-container">
            <!-- Header row -->
            <div class="grid-header d-flex justify-content-between">
              <div class="grid-cell text-center">{{$t('plovila.table.registracija')}}</div>
              <div class="grid-cell text-center">{{$t('plovila.table.s_ure')}}</div>
              <div class="grid-cell text-center">{{$t('plovila.table.s_letov')}}</div>
              <div class="grid-cell text-center">{{$t('plovila.table.tip')}}</div>
              <div class="grid-cell text-center">{{$t('plovila.table.vrsta')}}</div>
              <div class="grid-cell text-center">{{$t('plovila.table.podrobno')}}</div>
            </div>

            <!-- data row -->
            <div class="grid-row d-flex justify-content-between" v-for='letalo in FilterLetal' @click.prevent='Podrobno(letalo.id)'>
              <div class="grid-cell text-white text-center">{{letalo.registracija}}</div>
              <div class="grid-cell text-white center">{{(letalo.camo_flight) ? letalo.ure_in_letenje_camo : letalo.ure_in_letenje }}</div>
              <div class="grid-cell text-white center">{{letalo.s_st_letov}}</div>
              <div class="grid-cell text-white center">{{letalo.tip}}</div>
              <div class="grid-cell text-white text-center">{{letalo.vrsta_letala}}</div>
              <div class="grid-cell text-white text-center">
                <button type="button"
                        class="btn btn-primary mb-3"
                        @@click.prevent='Podrobno(letalo.id)'>
                  <span><i class="far fa-id-card"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Mobile/Tablet Multi-Select View -->
        <div class="mobile-multiselect">
          <div class="remarks-item">
            <div class="area-selection">
              <div class='row mt-3' v-for='letalo in FilterLetal' @click.prevent='Podrobno(letalo.id)'>
                <!--TEST PRIKAZ MOBILE-->
                <!-- LEVI STOLPEC -->
                <div class="col-6 d-flex flex-column">
                  <div class="text-white text-start">{{$t('plovila.table.registracija')}}</div>
                  <div class="text-white text-start">{{$t('plovila.table.s_ure')}}</div>
                  <div class="text-white text-start">{{$t('plovila.table.s_letov')}}</div>
                  <div class="text-white text-start">{{$t('plovila.table.tip')}}</div>
                  <div class="text-white text-start d-none d-md-block">
                    {{$t('plovila.table.podrobno')}}
                  </div>
                </div>

                <!-- DESNI STOLPEC -->
                <div class="col-6 d-flex flex-column">
                  <div class="text-white text-end text-limit">{{letalo.registracija}}</div>
                  <div class="text-white text-end text-limit">{{(letalo.camo_flight) ? letalo.ure_in_letenje_camo : letalo.ure_in_letenje }}</div>
                  <div class="text-white text-end text-limit">{{letalo.s_st_letov}}</div>
                  <div class="text-white text-end text-limit">{{letalo.tip}}</div>

                  <!-- Desktop gumb -->
                  <div class="text-center d-none d-md-block">
                    <button type="button" class="btn btn-primary w-100">
                      <i class="far fa-id-card"></i>
                    </button>
                  </div>
                </div>

                <!-- Mobile gumb -->
                <div class="col-12 d-md-none mt-2">
                  <button type="button" class="btn btn-primary w-100" @click.prevent='Podrobno(letalo.id)'>
                    <i class="far fa-id-card"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- LETALA PODROBNO -->
    <div class="modal modal-kartica" ref="modalKarticaLetala" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content list-dark border-orange" v-if="izbranoLetalo.length > 0" >
          <div class='d-flex justify-content-between'>
            <div class="badge-camo">
              <span>
                Stanje na {{ new Date().toISOString().split('T')[0].split('-').reverse().join('.')}}
              </span>
                <br/>
                <span class="text-start mt-2">{{ new Date().toLocaleTimeString("sl-SL") }}</span>
            </div>
            <button class="modern-close-btn mt-2 me-2" @click.prevent="PodrobnoOff">
              <span aria-hidden="true"><i class="fas fa-2x fa-times"></i></span>
            </button>
          </div>
          <!-- Navigation Tabs -->
          <div class='modal-header justify-content-between'>
            <h5 class="card-title"><i class="fas fa-plane fa-lg"></i> {{izbranoLetalo[0].registracija}}</h5>
            <button class="btn btn-outline-warning"
                    @click.prevent="PrenosPdf()"
                    :disabled="prenos"
            >
              <i class="fas fa-spinner fa-spin" v-if="prenos"></i>  <i class="fas fa-file-pdf"></i> Prenos pdf
            </button>
            <button class="btn btn-outline-warning"
                    @click.prevent="SendToMail()"
                    :disabled="posiljanje"
            >
              <i class="fas fa-spinner fa-spin" v-if="posiljanje"></i>  <i class="fas fa-envelope"></i> Email
            </button>
          </div>
          <div class='modal-header justify-content-between'>
            <h5 class='meni col-8'><i class="fas fa-file-alt"></i> Podatki letala</h5>
            <hr/>
          </div>

          <!-- PREGLED PODAKTOV -->
          <div class="modal-body col-12">
            <ul class='list-group list-group-flush'>
              <!-- <li class='list-group-item'>registracija: {{izbranoLetalo[0].registracija}}</li> -->
              <li class='list-group-item list-dark'>{{$t('plovila.modal.vlecno')}} <i class="fas" :class="{'fa-times text-danger': !izbranoLetalo[0].vlecno, 'fa-check text-success': izbranoLetalo[0].vlecno }"></i></li>
              <li class='list-group-item list-dark'>{{$t('plovila.modal.tip')}}  <span class='text-lorange'> {{izbranoLetalo[0].tip}}</span></li>
<!--              <li class='list-group-item list-dark'>{{$t('plovila.modal.stUr')}}  <span class='text-lorange'> {{izbranoLetalo[0].st_ur}}</span></li>-->
<!--              <li class='list-group-item list-dark'>{{$t('plovila.modal.stLetov')}}  <span class='text-lorange'> {{izbranoLetalo[0].st_letov}}</span></li>-->
              <li class='list-group-item list-dark'>{{$t('plovila.modal.vrsta')}}  <span class='text-lorange'> {{izbranoLetalo[0].vrsta_letala}}</span></li>
              <li class='list-group-item list-dark'>{{$t('plovila.modal.datumN')}}  <span class='text-lorange'> {{izbranoLetalo[0].datum_nakupa.split('-').reverse().join('.')}}</span></li>
              <li class='list-group-item list-dark'>{{$t('plovila.modal.datumR')}}  <span class='text-lorange'> {{izbranoLetalo[0].datum_registracije.split('-').reverse().join('.')}}</span></li>
            </ul>
          </div>
          <div class='modal-header justify-content-between'>
            <h5 class='meni col-8'><i class="fas fa-tools"></i> Servisni podatki</h5>
            <hr/>
          </div>
          <div class="modal-body col-12">
          <!-- /PREGLED -->
          <!-- SERVISNA KNJIGA -->
            <ul class='list-group list-group-flush'>
<!--              <li class='list-group-item list-dark'>{{$t('plovila.modal.stLetov')}} <span class='text-lorange'>{{izbranoLetalo[0].st_letov}}</span></li>-->
              <li class='list-group-item list-dark'>{{$t('plovila.modal.servis.stLetov')}} <span class='text-lorange'>{{izbranoLetalo[0].s_st_letov}}</span></li>
<!--              <li class='list-group-item list-dark'>{{$t('plovila.modal.stUr')}} <span class='text-lorange'>{{izbranoLetalo[0].st_ur}}</span></li>-->
              <li class='list-group-item list-dark'>{{$t('plovila.modal.servis.stSUr')}} <span class='text-lorange'>{{izbranoLetalo[0].ure_in_letenje_camo }}</span></li>
              <li class='list-group-item list-dark'>{{$t('plovila.modal.servis.interval')}} <span class='text-lorange'>{{izbranoLetalo[0].servisni_interval == null ? '/' : izbranoLetalo[0].servisni_interval}}</span></li>
              <li class='list-group-item list-dark'>{{$t('plovila.modal.servis.datum_zServis')}}  <span class='text-lorange'>{{izbranoLetalo[0].servis_opravljen == null ? '/' : izbranoLetalo[0].servis_opravljen.split('-').reverse().join('.')}}</span></li>
              <li class='list-group-item list-dark'>{{$t('plovila.modal.servis.opravljen_servis')}} <span class='text-lorange'>{{izbranoLetalo[0].zadnji_servis == null ? '/' : izbranoLetalo[0].zadnji_servis}}</span></li>
              <li class='list-group-item list-dark'>{{$t('plovila.modal.servis.naslednji_servis')}} <span class='text-lorange'>{{izbranoLetalo[0].datum_servisa == null ? '/' : izbranoLetalo[0].datum_servisa.split('-').reverse().join('.')}}</span></li>
              <li class='list-group-item list-dark'>{{$t('plovila.modal.servis.status')}}
                <span class='service-status' :class="{'status-ok': izbranoLetalo[0].status === 'ok', 'status-danger': izbranoLetalo[0].status !== 'ok'}">
                <i class="fas fa-circle" :class="{'text-success': izbranoLetalo[0].status === 'ok', 'text-danger': izbranoLetalo[0]['status'] !== 'ok'}"></i> {{ izbranoLetalo[0].status === 'ok' ? 'Letalo plovno' : 'Letalo ni plovno' }}
              </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<style>
.badge-camo {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 1.65em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
  background: rgba(48,122,204,.15);
}
</style>